export default __webpack_public_path__ + "static/Quickinstallation_Lense-Adjust_5907_02-4b48654f1cd7a265e7af7ca275f168d7.webp";